import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from "../apiConfig";
import CSRFToken from "../cookies.js";
import Employee from "../image/Employee.png";
import Navbar from "../Component/navbar.jsx";
import Footer from "../Component/footer.jsx";
import Crown from "../image/crown.png";
import { CgProfile } from "react-icons/cg";
import { LuContact2 } from "react-icons/lu";
import { CiLocationOn } from "react-icons/ci";

function Profile() {
  const [profileData, setProfileData] = useState(null);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();
  const [imageDataUrl, setImageDataUrl] = useState(null);
  const [inputs, setInputs] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phoneNumber: "",
    street: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    gender: "",
    dob: "",
    profileImage: "",
  });

  const [submit, setSubmit] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [saveTimeout, setSaveTimeout] = useState(null);
  const [saveMessage, setSaveMessage] = useState("Saved");

  const [editAccount, setEditAccount] = useState(false);
  const [changeImg, setChangeImg] = useState(false);
  const [editEmail, setEditEmail] = useState(false);
  const [editAddress, setEditAddress] = useState(false);

  const [editMode, setEditMode] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setUnsavedChanges(true);
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setInputs((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setUnsavedChanges(true);
  };

  const handleImageChange = async (e) => {
    const fileInput = e.target.files[0];
    if (fileInput) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Data = reader.result;
        setImageDataUrl(base64Data);
        setInputs((prevData) => ({
          ...prevData,
          profileImage: base64Data,
        }));
        setUnsavedChanges(true);
      };
      reader.readAsDataURL(fileInput);
      await saveProfile();
    } else {
      console.error("No file selected or target files is undefined");
    }
  };

  const saveProfile = async () => {
    if (isSaving) return;

    setIsSaving(true);
    setButtonDisabled(true);
    setSaveMessage("Saving...");

    const authToken = localStorage.getItem("access");
    if (!authToken) {
      navigate("/login");
      return;
    }

    const formData = new FormData();
    formData.append("first_name", inputs.firstname);
    formData.append("last_name", inputs.lastname);
    formData.append("email", inputs.email);
    formData.append("phone", inputs.phoneNumber);
    formData.append("address", inputs.street);
    formData.append("city", inputs.city);
    formData.append("state", inputs.state);
    formData.append("country", inputs.country);
    formData.append("pincode", inputs.pincode);
    formData.append("gender", inputs.gender);
    formData.append("dob", inputs.dob);
    if (imageDataUrl) {
      formData.append("profile_pic", imageDataUrl);
    }

    try {
      const response = await fetch(`${API_URL}/update-user-profile`, {
        method: "POST",
        headers: {
          "X-CSRFToken": CSRFToken(document.cookie),
          Authorization: `Bearer ${authToken}`,
        },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Profile updated successfully:", data);
        setUserData(`Hi ${inputs.firstname}! Your profile has been updated.`);
        setSaveMessage("Saved");
        setUnsavedChanges(false);
      } else {
        const errorData = await response.json();
        setSaveMessage("Error! Saving");
        console.error("Error updating profile:", errorData);
      }
    } catch (error) {
      setSaveMessage("Error! Saving");
      console.error("Error:", error);
    } finally {
      setButtonDisabled(false);
      setIsSaving(false);
    }
  };

  useEffect(() => {
    if (unsavedChanges) {
      if (saveTimeout) clearTimeout(saveTimeout);
      setSaveTimeout(setTimeout(saveProfile, 2000));
    }
  }, [inputs, imageDataUrl]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await saveProfile();
  };

  const fetchProfileData = async () => {
    try {
      const authToken = localStorage.getItem("access");

      if (!authToken) {
        navigate("/login");
        return;
      }

      const response = await fetch(`${API_URL}/fetch-user-profile`, {
        method: "GET",
        headers: {
          "X-CSRFToken": CSRFToken(document.cookie),
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status === 401) {
        navigate("/login");
        return;
      }
      if (response.status === 404) {
        const data = await response.json();
        setUserData(`Welcome ${data.name}!`);
        return;
      }

      const data = await response.json();
      setProfileData(data);
      setInputs({
        firstname: data.first_name || "",
        lastname: data.last_name || "",
        email: data.email || "",
        phoneNumber: data.phone || "",
        street: data.address || "",
        city: data.city || "",
        state: data.state || "",
        country: data.country || "",
        pincode: data.pincode || "",
        gender: data.gender || "",
        dob: data.dob || "",
        profileImage: data.profile_pic || Employee,
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />

      <main className="flex flex-col items-center justify-center px-4 py-8 bg-white lg:px-8 lg:py-12">
        {/* Main section */}
        <div className="w-full max-w-6xl p-6 bg-white rounded-lg shadow-lg lg:p-8">
          {/* Header */}
          <div className="text-[#313B47] text-2xl lg:text-4xl font-bold mb-6 text-center">
            <h1>Hi! {inputs?.firstname}</h1>
          </div>

          {/* Image */}
          <div className="flex justify-center mb-6">
            <div
              className="relative w-40 h-40 cursor-pointer"
              onMouseEnter={() => setChangeImg(true)}
              onMouseLeave={() => setChangeImg(false)}
            >
              <img
                src={inputs?.profileImage || "default_image_url_here"}
                alt="Profile"
                className="rounded-full w-full h-full border-4 border-[#313B47] transition-all duration-500 ease-out"
              />
              {changeImg && (
                <button
                  className="absolute top-1/2 right-0 transform -translate-y-1/2 bg-[#1D6362] text-white px-4 py-2 rounded-xl border border-black hover:bg-white hover:text-[#1D6362] transition-colors duration-300"
                  onClick={() => document.getElementById("imageUpload").click()}
                >
                  Change
                </button>
              )}
            </div>
            <input
              type="file"
              id="imageUpload"
              accept=".png, .jpg, .jpeg"
              className="hidden"
              onChange={handleImageChange}
            />
          </div>

          <div className="flex flex-row mb-6 space-x-4">
            <div className="flex justify-end w-full p-4 text-black rounded-lg ">
              <div className="flex flex-col items-end">
                <p className="mb-1 text-black">Plan Type</p>
                <span className="text-lg font-semibold">Basic</span>
              </div>
            </div>
            <div className="flex justify-start w-full p-4 text-black rounded-lg">
              <div className="flex flex-col items-start">
                <p className="mb-1 text-black">Valid until</p>
                <span className="text-lg font-semibold">Lifetime</span>
              </div>
            </div>
          </div>

          {/* Plan upgrade */}
          <div className="relative sm:w-96  p-6 mb-6 rounded-lg bg-[#1d6362] mx-auto">
            <img
              src={Crown}
              alt="crown"
              className="absolute top-[-2rem] left-3 w-20"
            />
            <div className="text-center lg:text-left">
              <h5 className="mb-2 text-lg font-semibold text-white lg:text-xl">
                Elevate Your Experience!
              </h5>
              <p className="mb-4 text-white">
                Unlock exclusive features with an upgrade.
              </p>
              <Link to="/pricing">
                <button type="submit" className="btn">
                  Upgrade Now
                </button>
              </Link>
            </div>
          </div>

          {/* Containers */}
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            {/* Account */}
            <div className="p-6 bg-[#1d6362] rounded-lg text-white">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center">
                  <CgProfile className="mr-2 w-7 h-7" />
                  <h5 className="text-xl font-semibold">Account</h5>
                </div>
                <button
                  className="text-lg"
                  onClick={() => setEditAccount(!editAccount)}
                >
                  {editAccount ? "Save" : "Edit"}
                </button>
              </div>

              {editAccount ? (
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <div>
                    <h4 className="mb-2 text-sm">First Name</h4>
                    <input
                      type="text"
                      name="firstname"
                      value={inputs.firstname}
                      onChange={handleChange}
                      className="w-full text-lg bg-[#2a7978] text-white border rounded-lg p-2"
                    />
                  </div>
                  <div>
                    <h4 className="mb-2 text-sm">Last Name</h4>
                    <input
                      type="text"
                      name="lastname"
                      value={inputs.lastname}
                      onChange={handleChange}
                      className="w-full text-lg bg-[#2a7978] text-white border rounded-lg p-2"
                    />
                  </div>
                  <div>
                    <h4 className="mb-2 text-sm">DOB</h4>
                    <input
                      type="date"
                      name="dob"
                      value={inputs.dob}
                      onChange={handleChange}
                      className="w-full text-lg bg-[#2a7978] text-white border rounded-lg p-2"
                    />
                  </div>
                </div>
              ) : (
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <div>
                    <h4 className="mb-1 text-sm">First Name</h4>
                    <span className="text-lg">{inputs.firstname || "NA"}</span>
                  </div>
                  <div>
                    <h4 className="mb-1 text-sm">Last Name</h4>
                    <span className="text-lg">{inputs.lastname || "NA"}</span>
                  </div>
                  <div>
                    <h4 className="mb-1 text-sm">DOB</h4>
                    <span className="text-lg">{inputs.dob || "NA"}</span>
                  </div>
                </div>
              )}
            </div>

            {/* Email */}
            <div className="p-6 bg-[#1d6362] rounded-lg text-white">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center">
                  <LuContact2 className="mr-2 w-7 h-7" />
                  <h5 className="text-xl font-semibold">Email</h5>
                </div>
                <button
                  className="text-lg"
                  onClick={() => setEditEmail(!editEmail)}
                >
                  {editEmail ? "Save" : "Edit"}
                </button>
              </div>

              {editEmail ? (
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1">
                  <div>
                    <h4 className="mb-1 text-sm">Email</h4>
                    <span className="text-lg">{inputs.email || "NA"}</span>
                  </div>
                  <div>
                    <h4 className="mb-2 text-sm">Phone</h4>
                    <input
                      type="text"
                      name="phoneNumber"
                      value={inputs.phoneNumber}
                      onChange={handleChange}
                      className="w-full text-lg bg-[#2a7978] text-white border rounded-lg p-2"
                    />
                  </div>
                </div>
              ) : (
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <div>
                    <h4 className="mb-1 text-sm">Email</h4>
                    <span className="text-lg">{inputs.email || "NA"}</span>
                  </div>
                  <div>
                    <h4 className="mb-1 text-sm">Phone</h4>
                    <span className="text-lg">
                      {inputs.phoneNumber || "NA"}
                    </span>
                  </div>
                </div>
              )}
            </div>

            {/* Address */}
            <div className="p-6 bg-[#1d6362] rounded-lg text-white">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center">
                  <CiLocationOn className="mr-2 w-7 h-7" />
                  <h5 className="text-xl font-semibold">Address</h5>
                </div>
                <button
                  className="text-lg"
                  onClick={() => setEditAddress(!editAddress)}
                >
                  {editAddress ? "Save" : "Edit"}
                </button>
              </div>

              {editAddress ? (
                <div>
                  <h4 className="mb-2 text-sm">Address Line 1</h4>
                  <input
                    type="text"
                    name="street"
                    value={inputs.street}
                    onChange={handleChange}
                    className="w-full text-lg bg-[#2a7978] text-white border rounded-lg p-2 mb-2"
                  />
                  <h4 className="mb-2 text-sm">City</h4>
                  <input
                    type="text"
                    name="city"
                    value={inputs.city}
                    onChange={handleChange}
                    className="w-full text-lg bg-[#2a7978] text-white border rounded-lg p-2 mb-2"
                  />
                  <h4 className="mb-2 text-sm">State</h4>
                  <input
                    type="text"
                    name="state"
                    value={inputs.state}
                    onChange={handleChange}
                    className="w-full text-lg bg-[#2a7978] text-white border rounded-lg p-2 mb-2"
                  />
                  <h4 className="mb-2 text-sm">Zip Code</h4>
                  <input
                    type="text"
                    name="pincode"
                    value={inputs.pincode}
                    onChange={handleChange}
                    className="w-full text-lg bg-[#2a7978] text-white border rounded-lg p-2"
                  />
                </div>
              ) : (
                <div>
                  <h4 className="mb-1 text-sm">Address</h4>
                  <span className="text-lg">{inputs?.street},</span>
                  <span className="text-lg">
                    {inputs.city}, {inputs?.state}, {inputs.pincode}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Profile;
